import { Partner} from "./models/partner.model";
import { Injectable } from "@angular/core";

@Injectable()
export class PartnerService{
  constructor(){
    
  }
  getListPartner():Partner[]{
    let partnerList:Partner[]=[];
    partnerList.push( new Partner(1, 'Ebay'));
    partnerList.push( new Partner(0, 'FPT'));
    return partnerList;
  }
}